import React from "react";
import { amountFormatter } from "services";
import { Button } from "../../../../shadcn/components/ui/button";

interface SimpleBidControlsProps {
  draftBidAmount: number;
  connectionStatus: "Online" | "Offline" | "Connecting";
  onDecreaseDraftBid: () => void;
  onIncreaseDraftBid: () => void;
  onPlaceBid: () => void;
}

export default function SimpleBidControls({
  draftBidAmount,
  connectionStatus,
  onDecreaseDraftBid,
  onIncreaseDraftBid,
  onPlaceBid,
}: SimpleBidControlsProps) {
  return (
    <div className="flex flex-col gap-[14px] relative mt-2">
      <div className="flex items-center">
        <Button
          className="rounded-none px-3"
          onClick={onDecreaseDraftBid}
          disabled={connectionStatus !== "Online"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.8008 12.9078H6V12H17.8008V12.9078Z"
              fill="white"
            />
          </svg>
        </Button>
        <div className="w-full text-center text-sm border-y-[1px] h-[38px] flex items-center justify-center tracking-wider">
          ₹ {amountFormatter(draftBidAmount)}
        </div>
        <Button
          className="rounded-none px-3"
          onClick={onIncreaseDraftBid}
          disabled={connectionStatus !== "Online"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12.75 11.25V6H11.25V11.25H6V12.75H11.25V18H12.75V12.75H18V11.25H12.75Z"
              fill="white"
            />
          </svg>
        </Button>
      </div>
      <Button className="w-full" onClick={onPlaceBid}>
        Place bid
      </Button>
    </div>
  );
}
